import { Component, Input, EventEmitter, Output } from '@angular/core';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-dialog-header',
  template: `
    <mat-progress-bar
      mode="indeterminate"
      class="fixed extreme-tl"
      color="accent"
      *ngIf="showProgress"
    ></mat-progress-bar>

    <div
      class="wrapper"
      fxLayout="column"
      [style.background-color]="headerBgColour"
      [style.padding-bottom]="titleDescription ? '7px' : '2px'"
      [style.padding]="isLarge ? '15px 30px' : '0 15px'"
      style="color: white"
      [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
    >
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div
            mat-dialog-title
            class="margin-none force"
            [ngClass]="{ bold: !isLarge }"
            [ngStyle]="{ 'font-size': isLarge ? '30px' : '' }"
            [style.color]="headerTextColour"
          >
            {{ dialogTitle }}
          </div>
          <small *ngIf="titleDescription" style="color: white; font-weight: bold">{{ titleDescription }}</small>
        </div>

        <span fxFlex></span>

        <div class="button-container">
          <button
            *ngIf="showPrint"
            class="action-button"
            [style.backgroundColor]="actionBtnBgColour"
            (click)="print()"
            mat-icon-button
          >
            <mat-icon>print</mat-icon>
          </button>
          <button
            *ngIf="!hideClose"
            mat-icon-button
            mat-dialog-close
            class="action-button"
            (click)="dialogClosed()"
            [style.backgroundColor]="actionBtnBgColour"
          >
            <mat-icon style="position: relative; color: white"> close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <mat-divider *ngIf="!hideDivider"></mat-divider>
  `,
  styles: [
    `
      .action-button {
        height: 52px;
        width: 52px;
        border-radius: 0;
      }

      .button-container {
        display: flex;
        margin: 0 -10px 0 0;
        align-items: center;
      }

      :host ::ng-deep .close-button .mat-button-wrapper {
        height: auto;
        line-height: 1;
      }

      .close-button-desc {
        top: 0px;
        right: -15px;
      }

      .close-button-no-desc {
        top: -10px;
        right: -15px;
      }

      .wrapper[dir='rtl'] .close-button-desc,
      .wrapper[dir='rtl'] .close-button-no-desc {
        right: auto;
        left: -15px;
      }
    `,
  ],
})
export class DialogHeaderComponent {
  private companyColour = this.cService.userProfile ? '#' + this.cService.userProfile.HqColour : '';

  @Input() dialogTitle: string;
  @Input() titleDescription?: string;
  @Input() showProgress: boolean = false;
  @Input() hideClose: boolean = false;
  @Input() hideDivider: boolean = false;
  @Input() showPrint = false;
  @Input() printFileName = document.title;
  @Input() actionBtnBgColour: string = this.companyColour;
  @Input() headerBgColour: string = this.companyColour;
  @Input() headerTextColour: string = '';
  @Input() isLarge: boolean = false;

  // NOTE: Use only when the X sign is the only means to close the dialog
  // else, other means would have to be handled.
  @Output() dialogClosedViaRedX = new EventEmitter();

  constructor(public cService: CommonService) {}

  dialogClosed() {
    this.dialogClosedViaRedX.emit({ closed: true });
  }

  public print() {
    const oldTitle = document.title;
    document.title = this.printFileName;
    window.print();
    document.title = oldTitle;
  }
}
